import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import * as routes from './IntegrationsRoutes';
import { ExactGlobePage } from './exactGlobe/ExactGlobePage';
import { ExactOnlineIntegrationPage } from './exactOnline/ExactOnlineIntegrationPage';
import { InvoiceForwardingIntegrationPage } from './invoiceForwarding/InvoiceForwardingIntegrationPage';
import { RosaIntegrationPage } from './rosa/RosaIntegrationPage';
import { PeppolPage } from './peppol/peppol.page';
import { CochlearPage } from './cochlear/cochlear.page';

export const IntegrationsSwitch = () => {
	return (
		<Switch>
			<Route
				exact
				path={routes.RosaRoute}
				component={RosaIntegrationPage}
			/>
			<Route
				exact
				path={routes.ExactOnlineRoute}
				component={ExactOnlineIntegrationPage}
			/>
			<Route
				exact
				path={routes.ExactGlobeRoute}
				component={ExactGlobePage}
			/>
			<Route
				exact
				path={routes.InvoiceForwardingRoute}
				component={InvoiceForwardingIntegrationPage}
			/>
			<Route
				exact
				path={routes.PeppolRoute}
				component={PeppolPage}
			/>
			<Route
				exact
				path={routes.CochlearRoute}
				component={CochlearPage}
			/>
			<Redirect to={routes.RosaRoute} />
		</Switch>
	);
};
